import { Logger, EngineComponentFactory } from "neo-common";
import { ActionSet } from "../ActionSet";
import { ComponentTypes } from "../ComponentTypes";

/**
 * The ActionManager class is used for parsing elements which are extending display objects and render them to canvas.
 * @class ActionManager
 * @author Marek Turkovic
 *
 *  <Actions123 Class="ActionSet">
 *      <Elements>
 *          <Hocico LinkedToId="123" Class="LinkedElement"/>
 *      </Elements>
 *      <Actions>
 *          <Action Case="PackOfActions1">
 *              <Hocico RotationTween="50" />
 *          </Action>
 *          <Action Case="PackOfActions2">
 *              <Hocico Scale="0.5" Tint="ff0000" Rotation="45"/>
 *          </Action>
 *      </Actions>
 *  </Actions123>
 */
export class ActionManager {
    /**
     * Parse ActionSet object elements from xml and add them to ActionSet.ActionSets object.
     *
     * @method parseActionSets
     * @param startNode
     * @return void
     */
    static parseActionSets(startNode: Element): void {
        if (!startNode) {
            return;
        }

        ActionManager.getNodesList(startNode.firstElementChild)
            .reverse()
            .filter(
                (node: Element) =>
                    node.hasAttribute("Class") &&
                    node.getAttribute("Class") === "ActionSet" &&
                    EngineComponentFactory.isTypeOf("ActionSet", ComponentTypes.ActionSet),
            )
            .forEach((node: Element) => (EngineComponentFactory.get("ActionSet") as ActionSet).RegisterActionSet(node));
    }

    /**
     * Recursively extracts sibling nodes.
     * @method getNodesList
     * @param node Element
     * @param nodeList Array<Element>
     * @return Array<Element>
     */
    private static getNodesList(node: Element, nodeList: Array<Element> = []): Array<Element> {
        if (!node) {
            return nodeList;
        }

        if (node.nextElementSibling) {
            nodeList = ActionManager.getNodesList(node.nextElementSibling, nodeList);
        }

        return nodeList.concat(node);
    }

    /**
     * Trace to browser console.
     * @method log
     * @param data any
     * @return void
     */
    private static log(data: any): void {
        if (DEBUG) {
            Logger.debugGroup("ActionManager", data);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Managers/ActionManager.ts
 **/